import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  selectedProgram: null,
  programs: [],
  loading: false,
  error: null
};

const programSlice = createSlice({
  name: 'program',
  initialState,
  reducers: {
    setSelectedProgram: (state, action) => {
      state.selectedProgram = action.payload;
    },
    setPrograms: (state, action) => {
      state.programs = action.payload;
    },
    updateProgram: (state, action) => {
      const updatedProgram = action.payload;
      state.programs = state.programs.map(program => 
        program.programId === updatedProgram.programId ? updatedProgram : program
      );
      if (state.selectedProgram?.programId === updatedProgram.programId) {
        state.selectedProgram = updatedProgram;
      }
    },
    clearSelectedProgram: (state) => {
      state.selectedProgram = null;
    }
  }
});

export const { setSelectedProgram, setPrograms, updateProgram, clearSelectedProgram } = programSlice.actions;
export default programSlice.reducer; 